import React from 'react'
import { Roll } from './ElementsStyles'
import { ReactComponent as DiceSVG } from '../../../../lib/assets/redDice.svg'

export default function PlayButton() {
  return (
    <Roll under width={'100%'} fontSize={'26px'} shadow>
      Roll to win <span>$100.00</span>
      <DiceSVG />
    </Roll>
  )
}
